import { createSlice } from '@reduxjs/toolkit';

const initialState = {};
/* eslint-disable no-param-reassign */
export const wizardSlice = createSlice({
  name: 'wizard',
  initialState,
  reducers: {
    sendDataToServer: (state) => {
      state.loading = true;
      state.actionRequired = true;
      state.error = false;
      state.errorMessage = '';
    },
    initUpdate: (state) => {
      state.loading = true;
      state.actionRequired = false;
    },
    successUpdate: (state) => {
      state.loading = false;
      state.actionRequired = false;
      state.error = false;
      state.errorMessage = '';
      state.success = true;
    },
    failUpdate: (state) => {
      state.loading = false;
      state.actionRequired = false;
      state.error = true;
      state.errorMessage = 'Generic error. Please contact site admin';
      state.success = false;
    },
    resetSuccess: (state) => {
      state.success = false;
    },
    setStep: (state, action) => {
      const { payload } = action;
      state.success = false;
      state.step = payload;
    },
    setSubStep: (state, action) => {
      const { payload } = action;
      state.success = false;
      state.subStep = payload;
    },
    setStepValidation: (state, action) => {
      const { payload } = action;
      state.validStep = payload;
    },
    validateForm: (state, action) => {
      const { payload } = action;
      state.validateForm = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  sendDataToServer,
  failUpdate,
  initUpdate,
  successUpdate,
  resetSuccess,
  setStep,
  setSubStep,
  setStepValidation,
  validateForm,
} = wizardSlice.actions;
export const wizardState = (state) => state.wizard;
export default wizardSlice.reducer;
